import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { practicalInformationApi } from 'src/Services/API';

const useFetchPracticalInformation = (practicalInformationId: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-practical-information', assetId, practicalInformationId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (
        await practicalInformationApi.practicalInformationControllerFindOne(
          assetId,
          practicalInformationId
        )
      ).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchPracticalInformation;
